// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

import { Button } from "@granite/ui";
import { Component, type ErrorInfo, type ReactNode } from "react";

import { t } from "../lib/i18n.js";
import { WindowDragStrip } from "./WindowChrome.js";

/** Full-page fallback for errors nothing else handled. */
export function CrashScreen() {
  return (
    <div role="alert" className="flex min-h-dvh flex-col items-center justify-center gap-3 bg-bg px-4 text-center">
      <WindowDragStrip />
      <h1 className="text-xl font-semibold text-fg">{t("crash.title")}</h1>
      <p className="max-w-sm text-sm text-fg-muted">{t("crash.body")}</p>
      <Button
        onClick={() => {
          window.location.reload();
        }}
      >
        {t("crash.reload")}
      </Button>
    </div>
  );
}

/** Catches render errors outside the router (the router has its own error component). */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Unhandled UI error", error, info.componentStack);
  }

  override render(): ReactNode {
    return this.state.failed ? <CrashScreen /> : this.props.children;
  }
}
